import { render, staticRenderFns } from "./ConsultationQuestionnaire.vue?vue&type=template&id=0707e876&scoped=true"
import script from "./ConsultationQuestionnaire.vue?vue&type=script&lang=js"
export * from "./ConsultationQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./ConsultationQuestionnaire.vue?vue&type=style&index=0&id=0707e876&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0707e876",
  null
  
)

export default component.exports